// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1PIvN","inputWrap":"Table_inputWrap__3Q76s","col":"Table_col__2XGxf","bmiTooltip":"Table_bmiTooltip__2Lvhu"};